<template>
    <div id="tipspage">
        <div>
            <img src="../../../static/img/404.png" alt="">
            <div class="saveBtn">
                <div @click="roteView"><el-button type="primary">立即返回</el-button></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'tipspage',
    data(){

    },
    methods:{
      roteView(){
        //   this.$router.go(-1)
        this.$router.push({path:'/content/Monitoring'});
      }
    }
}
</script>
<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
#tipspage{
    width: 100%;
    height: 100%;
    @include flexible;
    @include alignItems(center);
    @include justify(center);
    text-align: center;
    .saveBtn{
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        .el-button{
            width: 200px;
            height: 40px;
            padding: 0;
            font-size: 16px !important;
        }
        &>div{
            margin-right: 20px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/page/tipspage/index.vue